// Translation Editor controller
// Handles expand/collapse of inline translation detail panel below table rows.
// Detail panels are pre-rendered hidden in the page — JS just toggles visibility.
// The entire row is clickable (except the item code link).

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chevron", "detailPanel", "toggleButton"]
  static values = {
    itemId: String,
    expanded: { type: Boolean, default: false },
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  toggle() {
    const detail = this._detailElement()
    if (!detail) return

    const isHidden = detail.classList.contains("hidden")
    detail.classList.toggle("hidden")
    this.expandedValue = isHidden
    this._rotateChevron(isHidden)
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute(
        "aria-expanded",
        isHidden ? "true" : "false",
      )
    }

    if (isHidden) {
      requestAnimationFrame(() => this._fitDetailWidth())
    }
  }

  _fitDetailWidth() {
    const scrollContainer = this.element.closest(".overflow-x-auto")
    if (!scrollContainer) return

    const panel = document.querySelector(
      `#coverage-detail-${this.itemIdValue} [data-catalog--translation-editor-target="detailPanel"]`,
    )
    if (panel) {
      panel.style.width = `${scrollContainer.clientWidth}px`
    }
  }

  _detailElement() {
    return document.getElementById(`coverage-detail-${this.itemIdValue}`)
  }

  _rotateChevron(open) {
    if (!this.hasChevronTarget) return
    if (open) {
      this.chevronTarget.classList.add("rotate-90")
    } else {
      this.chevronTarget.classList.remove("rotate-90")
    }
  }
}
